import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner'

// Admin 内唯一的 Sonner 边界。页面和 hooks 只依赖当前实际使用的通知能力。
export const toast = {
  error: (...args: Parameters<typeof sonnerToast.error>) => sonnerToast.error(...args),
  success: (...args: Parameters<typeof sonnerToast.success>) => sonnerToast.success(...args),
  warning: (...args: Parameters<typeof sonnerToast.warning>) => sonnerToast.warning(...args)
}

export { SonnerToaster }
